import React from 'react';
import PropTypes from 'prop-types';
import { Title, Subtitle } from '../../Components/Header';
import Diagram from '../../Components/Diagram';
import Turnout from '../../Components/Turnout';
import { percentFormat } from '../../Utils/NumberFormatting';
import { Err } from '../../Symbols/Err';
import {
	getHasElectionFinished,
	getHasElectionStarted
} from '../../Utils/Getters';
import { MandatesOverview } from '../../Components/Regional/MandatesOverview';
import { MandatesComposition } from '../../Components/Regional/MandatesComposition';

export default class Region extends React.Component {
	getSortedParties = (parties) => {
		if (!getHasElectionStarted(this.props.region.meta)) {
			return parties.slice().sort((a, b) => a.name.localeCompare(b.name));
		}
		return parties.slice().sort((a, b) => b.percent - a.percent);
	};

	render() {
		if (this.props.err) {
			return (
				<>
					<Err>Data nejsou zatím dostupná.</Err>
				</>
			);
		}

		const sortedParties = this.getSortedParties(this.props.region.parties)

		return (
			<>
				<Title.Input>
					Krajské volby {this.props.year} - {this.props.region.name || 'Načítám'}
				</Title.Input>
				<Subtitle.Input>Výsledky v jednotlivém kraji</Subtitle.Input>
				{this.props.hasData && !getHasElectionStarted(this.props.region.meta) && (
					<p>Zatím nebyly sečteny žádné hlasy.</p>
				)}
				{
					getHasElectionStarted(this.props.region.meta)
				&& <Turnout
					turnout={this.props.region.meta.turnout}
					count={this.props.region.meta.count}
				/>
				}
				<Diagram
					title="Kolik získaly strany hlasů"
					items={sortedParties}
					getValue={(item) => item.percent}
					renderValue={(props) => percentFormat(props.percent)}
				/>
				{getHasElectionFinished(this.props.meta) && (
					<>
						<MandatesOverview parties={sortedParties} />
						<MandatesComposition parties={sortedParties} />
					</>
				)}
			</>
		);
	}
}

Region.propTypes = {
	id: PropTypes.string.isRequired,
	rootUrl: PropTypes.string.isRequired,
	err: PropTypes.bool.isRequired,
	hasData: PropTypes.bool.isRequired,
	year: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]).isRequired,
	region: PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string,
		meta: PropTypes.shape({
			turnout: PropTypes.number,
			count: PropTypes.number,
			isFinal: PropTypes.bool
		}),
		parties: PropTypes.arrayOf(PropTypes.object)
	})
};

Region.defaultProps = {
	region: {
		meta: {},
		parties: []
	}
};
